import "react-app-polyfill/stable";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import App from "./App";
import * as serviceWorker from "./serviceWorker";
import {
  setPropertiesForChannel,
  setImageBaseUrls,
} from "./store/init/initSlice";
import { setApiConfigs } from "./store/requests/requestsSlice";
import store from "./store/store";
import { observeStore } from "./store/observeStore";
import { setStoredState } from "./store/storedState";
import { BFC_SPA_Uterum } from "./constants/constants";

const rootElement = document.getElementById("bfc-single-page-app");
const root = createRoot(rootElement);

let channelId = rootElement.getAttribute("data-channel-id");
if (
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_LOCALHOST_CHANNEL_ID
) {
  channelId = process.env.REACT_APP_LOCALHOST_CHANNEL_ID;
}

!rootElement && console.error("React root element is missing");

// The preview image relies on position: sticky, which silently stops working
// if an ancestor in the surrounding Scensum page template clips overflow.
const findClippingAncestor = (el) => {
  const clipping = ["hidden", "auto", "scroll", "clip"];

  for (
    let node = el && el.parentElement;
    node && node !== document.documentElement;
    node = node.parentElement
  ) {
    const { overflow, overflowX, overflowY } = window.getComputedStyle(node);

    if ([overflow, overflowX, overflowY].some((v) => clipping.includes(v))) {
      return node;
    }
  }

  return null;
};

const clippingAncestor = findClippingAncestor(rootElement);

clippingAncestor &&
  console.warn(
    "BFC SPA: An ancestor element clips overflow, which disables position: sticky for the preview image.",
    clippingAncestor
  );

!channelId && console.error("Scensum channel id is missing");

// Get assetBaseUrl
const assetBaseUrl = rootElement.getAttribute("data-asset-base-url");

!assetBaseUrl && console.error("Scensum asset_baseurl is missing");

const selectUterum = (state) => state.Uterum;
const onUterumChange = (Uterum) => {
  setStoredState(BFC_SPA_Uterum, Uterum);
};

// Observe store for changes in Uterum --> setStoredState on change
observeStore(store, onUterumChange, selectUterum);

// Get articleImageBaseUrl
const articleImageBaseUrl = rootElement.getAttribute(
  "data-article-image-base-url"
);
!articleImageBaseUrl &&
  console.error("BFC SPA: Scensum article_image_base_url is missing");

const cgeBaseUrl = rootElement.getAttribute("data-cge-base-url");
const scensumBaseUrl = rootElement.getAttribute("data-scensum-base-url");
const skbvApiBaseUrl = rootElement.getAttribute("data-skbv-api-base-url");

store.dispatch(setApiConfigs({channelId, cgeBaseUrl, scensumBaseUrl, skbvApiBaseUrl}));
store.dispatch(setPropertiesForChannel(channelId));
store.dispatch(
  setImageBaseUrls({
    assetBaseUrl,
    articleImageBaseUrl,
  })
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
